const browser = (function () {
  let u = navigator.userAgent;
  return {
    trident: u.indexOf('Trident') > -1, //IE内核
    presto: u.indexOf('Presto') > -1, //opera内核
    webKit: u.indexOf('AppleWebKit') > -1, //苹果、谷歌内核
    gecko: u.indexOf('Gecko') > -1 && u.indexOf('KHTML') == -1, //火狐内核
    mobile: !!u.match(/AppleWebKit.*Mobile.*/), //是否为移动终端
    ios: !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/), //ios终端
    android: u.indexOf('Android') > -1 || u.indexOf('Adr') > -1, //android终端
    iPhone: u.indexOf('iPhone') > -1, //是否为iPhone或者QQHD浏览器
    iPad: u.indexOf('iPad') > -1, //是否iPad
    webApp: u.indexOf('Safari') == -1, //是否web应该程序，没有头部与底部
    weixin: u.indexOf('MicroMessenger') > -1, //是否微信 （2015-01-22新增）
    qq: u.match(/\sQQ/i) == " qq" //是否QQ
  };
})();

const formatNumFn = (n) => {
  n = parseInt(n);
  if (!n) return '暂无';
  if (n >= 10000 && n < 100000000) return parseInt(n / 10000) + 'W';
  if (n >= 100000000) return parseInt(n / 100000000) + '亿';
};

const getScopeFn = (n) => {
  n = parseInt(n);
  if (!n && n !== 0) return '暂无';
  if (n < 50 && n >= 0) return 50;
  if (n >= 50 && n < 1000) return 1000;
}

const dateFormatFn = (date, index) => {
  let m;
  date = (typeof date == "string") ? new Date(date) : date;
  m = date.getMonth() + 1;
  m = m > 9 ? m : "0" + m;
  index = index ? index : date.getDate();
  index = index > 9 ? index : "0" + index;
  return `${date.getFullYear()}-${m}-${index}`;
}

function addDate(date, days) {
  var d = new Date(date);
  d.setDate(d.getDate() + days);
  var m = d.getMonth() + 1;
  return d.getFullYear() + '/' + m + '/' + d.getDate();
}

const getTwoWeeksFn = (date, status) => {
  var curMonDayDate;
  var curWeek = date.getDay(); //获取当前是周几，周日为0
  if (curWeek == 0) {
    curWeek = 7;
  }
  var stDay = status ? (1 - curWeek) : (0 - curWeek); //周一和当前差多少天，得出为非正数
  curMonDayDate = addDate(date, stDay); //获取当前周的周一日期
  var arrDate = [];
  for (var i = 0; i < 7; i++) {
    arrDate.push(addDate(new Date(curMonDayDate), i));
  }
  // console.log(arrDate)
  return arrDate;
}

const scrollTopFn = (fn, s = 15) => {
  let n = document.documentElement.scrollTop || document.body.scrollTop || 0,
      t = null;
  let step = n / 11;
  n = n - step < 0 ? 0 : n - step;
  t = setInterval(() => {
    window.scrollTo(0, n);
    if(n == 0) {
      clearInterval(t);
      fn && fn();
    }
    n = n - step < 0 ? 0 : n - step;
  }, s);
}

export const formatNum = formatNumFn

export const getScope = getScopeFn

export const dateFormat = dateFormatFn

export const getTwoWeeks = getTwoWeeksFn

export const scrollTop = scrollTopFn

export default {
  browser,
  formatNum,
  getScope,
  dateFormat,
  getTwoWeeks,
  scrollTop
}